export default __webpack_public_path__ + "static/media/NoClaimsFound.3b9320e8.svg";